<div class="image-wrapper">
  <div class="image" [class.required]="isRequired && (dedupedSelectedUri$ | async) === defaultPlaceHolder">
    <img
      #imgTag
      [class.brighten]="hover"
      [src]="dedupedSelectedUri$ | async"
      [style.max-height.px]="maxHeight"
      [style.max-width.px]="maxWidth"
      (load)="imageLoaded()"
      />
    @if (selectMedia) {
      <div class="image-cover" (mouseover)="onHover(true)" (mouseleave)="onHover(false)" [style.max-height.px]="maxHeight"
        [style.max-width.px]="maxWidth">
        <ng-content></ng-content>
      </div>
    }
  </div>
  @if ((isAdmin$ | async) && showOriginType) {
    <div class="origin-type">
      {{ 'media.origin_type.label' | translate }}
      <div class="origin-type-select">
        <mat-select [formControl]="originTypeControl" panelWidth="240">
          <!-- No source and archived sources are no longer offered, only shown on an image that has them (ES-2379). -->
          @if (originTypeControl.value === 'unknown') {
            <mat-option [value]="'unknown'">{{ 'media.origin_type.unknown' | translate | titlecase }}</mat-option>
          }
          @for (originType of (originTypeOptions$ | async); track originType.id) {
            @if (!originType.archived || originType.name === originTypeControl.value) {
              <mat-option [value]="originType.name">
                {{ originType.name }}
              </mat-option>
            }
          }
        </mat-select>
        @if (savingOriginType) {
          <mat-spinner [diameter]="16"></mat-spinner>
        }
      </div>
    </div>
  }

</div>
